import type { CodexEntry } from "@lancer-vtt/domain";
import { useWorldCodex } from "../../../../lib/codex/useWorldCodex";
import { useGameSessionContext } from "../../../../lib/game/GameSessionProvider";

/** The codex entry pinned as the table's narrative backdrop, or null (none, or no longer in the codex). */
export function useBackdropEntry(): CodexEntry | null {
  const { backdrop } = useGameSessionContext();
  const codex = useWorldCodex();
  if (backdrop === null) return null;
  return codex.entries.find((e) => e.id === backdrop) ?? null;
}
